import { buildFolderPath, buildImageBaseUrl, URLS } from '../../config/app-config';
import {flattenToc} from "../../services/tocApi.js";

import {transformCodeBlocks} from "../codeFormatter";

export const transformArticleHTML = (html, {product, version, language}, tocData, offlineMode) => {
    const s = html
        // update image sources
        .replace(/src="images\/(.*?)"/g, (_, filename) =>
            offlineMode
                ? `src="/data/${buildFolderPath({product, version, language})}/img/${filename}"`
                : `src="${buildImageBaseUrl({product, version, language})}/${filename}"`
        )
        // update internal links
        .replace(/href="([^"]+)\.html"/gi, (m, topicId) => {
            const flat = flattenToc(tocData);
            const found = flat.find(i => i.topic_id === topicId);
            return found
                ? `href="/?articleId=${found._id}&lang=${language}&ver=${version}&product=${product}"`
                : m;
        })
        // force external links into a new tab
        .replace(/<a\b([^>]*?)\bhref="([^"]+)"([^>]*)>/gi, (match, before, href, after) => {
                const lowerHref = href.toLowerCase();

                const isExternalHttp = lowerHref.startsWith('http://') || lowerHref.startsWith('https://');
                const isSameOrigin = isExternalHttp && lowerHref.startsWith(URLS.frontendBase.toLowerCase());

                if (!isExternalHttp || isSameOrigin) {
                    return match;
                }

                let updated = match;

                if (!/\btarget=/i.test(updated)) {
                    updated = updated.replace('<a', '<a target="_blank"');
                }

                if (!/\brel=/i.test(updated)) {
                    updated = updated.replace('<a', '<a rel="noopener noreferrer"');
                }
                return updated;
        });

    // add code formatting for c#
    return transformCodeBlocks(s);
};
